import API_BASE_URL from '../api';

export async function getLiveWallSnapshot(token) {
  const encodedToken = encodeURIComponent(token || '');
  const response = await fetch(`${API_BASE_URL}/public/live-wall/${encodedToken}/snapshot`);

  if (response.ok) {
    return response.json();
  }

  if (response.status === 403 || response.status === 404) {
    return { settings: { enabled: false }, data: null };
  }

  throw new Error(`Live Wall snapshot request failed with HTTP ${response.status}`);
}
